import { BaseService } from './../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-todo-list-item-action-dialog',
  templateUrl: './todo-list-item-action-dialog.component.html',
  styleUrls: ['./todo-list-item-action-dialog.component.scss']
})
export class ToDoListItemActionDialogComponent implements OnInit {
  form!: FormGroup;
  config!: any;

  constructor(
    public dialogRef: MatDialogRef<ToDoListItemActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private baseService: BaseService
  ) {
    console.log('dialog data', data);
    this.form = fb.group({
      toDoListItemId: [null, Validators.compose([Validators.required])],
      orderType: [null, Validators.compose([])],
      orderNumber: [null, Validators.compose([])],
      toDoListItemTypeId: [null, Validators.compose([])],
      additionalInfo: [null, Validators.compose([])],
      sysproBranch: [null, Validators.compose([])],
      sysproSalesperson: [null, Validators.compose([])],
      salespersonNotes: [
        null,
        Validators.compose([Validators.required, Validators.maxLength(200)])
      ],
      actionCategoryId: [null, Validators.compose([])]
    });

    this.form.controls['orderType'].disable();
    this.form.controls['orderNumber'].disable();
    this.form.controls['toDoListItemTypeId'].disable();
    this.form.controls['additionalInfo'].disable();
    this.form.controls['sysproBranch'].disable();
    this.form.controls['sysproSalesperson'].disable();
  }

  ngOnInit() {
    this.baseService
      .executeCommand<any>('portal_todo_list_item_action_config', {
        toDoListItemId: this.data.toDoListItemId,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.form.patchValue(response.data.initialFormValue);
          this.form.updateValueAndValidity();
          this.config = response.data;
        } else {
          this.dialogRef.close(undefined);
        }
      });
  }

  save(complete: boolean) {
    const fromValue = this.form.getRawValue();

    this.baseService
      .executeCommand<any>('portal_todo_list_item_modify', Object.assign({complete: complete}, fromValue))
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        } else {
        }
      });
  }
}
